import defaultActions from './defaultReduxActions';

const actions = defaultActions({ namespace: 'tariff-weight-rates' });

export const { find, create, get, patch, reducer, remove } = actions;

export default reducer;
